import { Grid, useMediaQuery } from "@mui/material";
import { Visibility } from "@mui/icons-material";

import { ListAction, ListActions, StyledListWrapper } from "@framework/styled";
import { PonziDepositStatus, type IPonziDeposit } from "@framework/types";
import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { useDialogView, useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { List, Pagination } from "@dzambalaorg/ui-kit";

import { PonziRewardComplexButton } from "../../../../../components/buttons";
import { PonziDepositSearchForm } from "./search";
import { StakesDialogView } from "./view";

const PONZI_DEPOSIT_URL = "/ponzi/stakes";
const PONZI_DEPOSIT_DIALOG_KEY = "ponziStakes";
const initialSearchValues = {
  ponziDepositStatus: [PonziDepositStatus.ACTIVE],
};

export const PonziDeposit = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IPonziDeposit>
  >(PONZI_DEPOSIT_URL, { enableInfiniteScroll: isMd }, void 0, initialSearchValues);

  const { viewItem, handleView, viewDialogUniqueKey, closeViewDialog, viewMode } = useDialogView<IPonziDeposit>();

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "ponzi", "ponzi.deposit"]} />

      <PageHeader message="pages.ponzi.deposit.title" />

      <PonziDepositSearchForm initialValues={initialSearchValues} />

      <ProgressOverlay isLoading={isLoading}>
        <StyledListWrapper count={allRows.length} isLoading={isLoading}>
          {allRows.map(stake => (
            <List.Item key={stake.id}>
              <List.ItemText>{stake.ponziRule?.title}</List.ItemText>
              <ListActions>
                <PonziRewardComplexButton stake={stake} />
                <ListAction
                  onClick={handleView(PONZI_DEPOSIT_DIALOG_KEY, stake, "view")}
                  message="form.tips.view"
                  icon={Visibility}
                />
              </ListActions>
            </List.Item>
          ))}
        </StyledListWrapper>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <Pagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}

      <StakesDialogView
        onCancel={closeViewDialog}
        onConfirm={closeViewDialog}
        open={viewDialogUniqueKey === `${PONZI_DEPOSIT_DIALOG_KEY}.${viewMode}`}
        viewItem={viewItem}
      />
    </Grid>
  );
};
